// extracted by mini-css-extract-plugin
export default {"bar":"DisclaimerBar_bar__3qujZ","inner":"DisclaimerBar_inner__kc1C9","label":"DisclaimerBar_label__pwdnB","icon":"DisclaimerBar_icon__qel7H","text":"DisclaimerBar_text__iA3C8"};